import { render, staticRenderFns } from "./Porterage.vue?vue&type=template&id=3d608326&"
import script from "./Porterage.vue?vue&type=script&lang=js&"
export * from "./Porterage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports